import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import realStateImg from "../../assets-user/RealStateImg.png";
import ContactForm from "../../components/public/userCommon/ContactForm";
import BhubaneswarTopDeveloper from "../../components/public/userDeveloperDetails/BhubaneswarTopDeveloper";
import NewLaunchListings from "../../components/public/userDeveloperDetails/NewLaunchListings";
import ReadyToMove from "../../components/public/userDeveloperDetails/ReadyToMove";
import UnderConstruction from "../../components/public/userDeveloperDetails/UnderConstruction";
import api from "../../configs/api";

const SkeletonLoader = () => {
  return (
    <div className="w-full animate-pulse">
      {/* Company Profile Skeleton */}
      <div className="bg-[#E8F0FF] p-6 lg:p-10 rounded-2xl mb-10">
        <div className="flex flex-col md:flex-row justify-between gap-6">
          <div className="flex flex-col gap-4 w-full md:w-1/3">
            <div className="w-64 h-52 bg-gray-300 rounded-xl"></div>
            <div className="h-6 w-40 bg-gray-300 rounded"></div>
            <div className="h-4 w-32 bg-gray-300 rounded"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 bg-white p-6 border rounded-xl w-full md:w-2/3">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex flex-col items-start space-y-2">
                <div className="w-20 h-10 bg-gray-300 rounded"></div>
                <div className="w-28 h-4 bg-gray-300 rounded"></div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Description Skeleton */}
      <div className="bg-white p-6 rounded-xl shadow mb-10">
        <div className="h-6 w-32 bg-gray-300 rounded mb-4"></div>
        <div className="space-y-3">
          <div className="w-full h-4 bg-gray-300 rounded"></div>
          <div className="w-full h-4 bg-gray-300 rounded"></div>
          <div className="w-3/4 h-4 bg-gray-300 rounded"></div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
        {[1, 2, 3].map((i) => (
          <div key={i} className="p-6 bg-white shadow rounded-xl">
            <div className="w-5 h-20 bg-gray-300 rounded absolute"></div>
            <div className="ml-8 space-y-2">
              <div className="w-16 h-8 bg-gray-300 rounded"></div>
              <div className="w-24 h-4 bg-gray-300 rounded"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Listings Skeleton */}
      <div className="space-y-6">
        {[1, 2].map((i) => (
          <div key={i} className="w-full h-48 bg-gray-200 rounded-xl"></div>
        ))}
      </div>
    </div>
  );
};

const CompanyProfile = ({ company }) => {
  const statsData = [
    { number: company.totalProjects, label: "Total No. of Projects" },
    { number: company.experienceYears, label: "Years of Experience" },
    { number: company.citiesCovered, label: "No. of cities covered" },
  ];

  return (
    <div className="bg-[#E8F0FF] flex items-center justify-center py-6">
      <div className="w-full md:rounded-2xl overflow-hidden p-4 sm:p-6 lg:p-10">
        <div className="flex flex-col items-center justify-center md:flex-row lg:items-center lg:justify-between gap-8">
          {/* Left Section */}
          <div className=" flex md:flex-1 flex-row md:flex-col self-start items-start gap-4">
            <div className="bg-white rounded-xl shadow-md">
              <img
                src={company.companyLogo || realStateImg}
                alt=""
                className="rounded-lg w-20 h-20 sm:w-36 sm:h-36"
              />
            </div>

            <div className="flex flex-col gap-1 md:gap-y-3">
              <h1 className="font-semibold text-xl sm:text-2xl lg:text-3xl text-primary-navy">
                {company.companyName}
              </h1>
              <p className="font-normal text-sm sm:text-base lg:text-lg text-text-secondary">
                Founded in the year{" "}
                <span className="font-medium  text-[#424242]">
                  {company.foundedYear}
                </span>
              </p>

              {company.reraId && (
                <p className="text-sm sm:text-base lg:text-lg text-text-secondary">
                  RERA ID:{" "}
                  <span className="font-medium text-primary-navy">
                    {company.reraId}
                  </span>
                </p>
              )}
            </div>
          </div>

          {/* Right Section */}
          <div className="bg-white md:w-[60%] border-2 py-3 sm:py-5 md:py-7 lg:py-10 px-3 sm:px-6 lg:px-16 rounded-l-[20px] sm:rounded-l-[40px] lg:rounded-l-[56px] w-full xl:w-[800px] md:h-[150px] lg:h-auto">
            <div className="grid grid-cols-3 gap-3 sm:gap-5 lg:gap-6 w-full lg:w-auto">
              {statsData.map((stat, index) => (
                <div
                  key={index}
                  className={`text-center sm:text-left ${
                    index !== 0 ? "border-l-0 sm:border-l-2 pl-0 sm:pl-4" : ""
                  }`}
                >
                  <div className="font-semibold text-2xl sm:text-3xl leading-[100%] text-primary-navy mb-2">
                    {stat.number}
                  </div>
                  <div className="font-medium text-xs sm:text-sm  text-text-secondary">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DeveloperDescription = ({ description }) => {
  return (
    <div className="w-full bg-gray-50 flex items-center justify-center">
      <div className="w-full bg-white rounded-lg shadow-md p-4 sm:p-6 lg:p-8">
        <h2 className="font-semibold tracking-wide text-base md:text-lg lg:text-xl text-primary-navy mb-2 sm:mb-3 ">
          Description
        </h2>

        <p className="font-normal text-xs md:text-sm lg:text-base text-text-secondary tracking-wide leading-loose text-justify">
          {description}
        </p>
      </div>
    </div>
  );
};

const DeveloperStatsCard = ({ company }) => {
  const stats = [
    { number: company.newLaunch, label: "New Launch" },
    { number: company.readyToMove, label: "Ready to Move" },
    { number: company.underConstruction, label: "Under Construction" },
  ];

  return (
    <div className="w-full flex items-center justify-center">
      <div className="grid grid-cols-3 gap-2 sm:gap-6 lg:gap-8 w-full">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="relative bg-white rounded-lg shadow-md p-2 sm:p-4 md:p-6"
          >
            <div className="absolute left-0 top-0 w-3 sm:w-4 lg:w-5 h-full bg-gradient-to-r from-[#B9D1FF] to-[#6F7E99] rounded-lg"></div>

            <div className="ml-4 sm:ml-6">
              <h3 className="font-semibold text-xl sm:text-2xl lg:text-3xl leading-[100%] text-primary-navy">
                {stat.number.toString().padStart(2, "0")}
              </h3>
              <p className="font-medium text-[0.7rem] sm:text-sm lg:text-base  text-text-secondary line-clamp-2 overflow-ellipsis">
                {stat.label}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const CompanyDetails = () => {
  const { companyId } = useParams();
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const fetchCompany = async () => {
      try {
        const { data } = await api.get(`/companies/${companyId}`);
        if (data?.success) {
          setCompany(data.company);
        }
      } catch (err) {
        console.error("Error fetching company:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCompany();
  }, [companyId]);

  if (loading) return <SkeletonLoader />;

  if (!company)
    return (
      <div className="w-full text-center py-20 text-xl text-red-500">
        Company not found.
      </div>
    );

  return (
    <div className="w-full overflow-hidden">
      <CompanyProfile company={company} />

      {/* Main Content Section */}
      <div className="relative grid grid-cols-1 lg:grid-cols-4 gap-4 lg:gap-6 px-4 sm:px-6 md:px-8 lg:px-10 py-6 lg:py-8">
        <div className="lg:col-span-3 space-y-6 lg:space-y-8">
          <DeveloperDescription description={company.description} />
          <DeveloperStatsCard company={company} />
          <NewLaunchListings />
          <ReadyToMove />
          <UnderConstruction />
        </div>

        <div className="lg:col-span-1">
          <ContactForm />
        </div>
      </div>

      <div className="px-4 sm:px-6 lg:px-8 pb-8">
        <BhubaneswarTopDeveloper />
      </div>
    </div>
  );
};

export default CompanyDetails;

// import React from "react";
// import realStateImg from "../../assets-user/RealStateImg.png";
// import NewLaunchListings from "../../components/public/userDeveloperDetails/NewLaunchListings";
// import ReadyToMove from "../../components/public/userDeveloperDetails/ReadyToMove";
// import UnderConstruction from "../../components/public/userDeveloperDetails/UnderConstruction";
// import ContactForm from "../../components/public/userCommon/ContactForm";
// import BhubaneswarTopDeveloper from "../../components/public/userDeveloperDetails/BhubaneswarTopDeveloper";
// import { useParams } from "react-router-dom";

// const CompanyProfile = () => {
//   const statsData = [
//     { number: 20, label: "Total No. of Projects" },
//     { number: 10, label: "Years of Experience" },
//     { number: 4, label: "No. of cities covered" },
//   ];

//   return (
//     <div className="bg-[#E8F0FF] flex items-center justify-center">
//       <div className="w-full rounded-2xl overflow-hidden p-4 sm:p-6 lg:p-10">
//         <div className="flex flex-col items-center justify-center md:flex-row lg:items-center lg:justify-between gap-8">
//           {/* Left Section */}
//           <div className="flex flex-col items-start gap-4">
//             <div className="bg-white rounded-xl shadow-md">
//               <img
//                 src={realStateImg}
//                 alt=""
//                 className="rounded-lg w-full max-w-[280px] sm:max-w-[320px] lg:max-w-none object-contain"
//               />
//             </div>

//             <div className="flex flex-col gap-1">
//               <h1 className="font-semibold text-[28px] text-[#1E1E1E]">
//                 DLF Limited
//               </h1>
//               <p className="font-normal text-[18px] text-[#424242]">
//                 Founded in the year{" "}
//                 <span className="font-medium text-[18px] text-[#424242]">
//                   1946
//                 </span>
//               </p>
//             </div>
//           </div>

//           {/* Right Section */}
//           <div className="bg-white border-2 py-6 sm:py-8 lg:py-10 px-6 sm:px-10 lg:px-16 rounded-l-[20px] sm:rounded-l-[40px] lg:rounded-l-[56px] w-full xl:w-[800px] md:h-[150px] lg:h-auto">
//             <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 w-full lg:w-auto">
//               {statsData.map((stat, index) => (
//                 <div
//                   key={index}
//                   className={`text-center sm:text-left ${
//                     index !== 0 ? "border-l-0 sm:border-l-2 pl-0 sm:pl-4" : ""
//                   }`}
//                 >
//                   <div className="font-semibold text-[40px] leading-[100%] text-[#1E1E1E] mb-2">
//                     {stat.number}
//                   </div>
//                   <div className="font-medium text-[18px] text-[#696969]">
//                     {stat.label}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const DeveloperDescription = () => {
//   return (
//     <div className="w-full bg-gray-50 flex items-center justify-center">
//       <div className="w-full bg-white rounded-lg shadow-md p-6 sm:p-8 lg:p-8">
//         <h2 className="font-medium text-[22px] text-[#1E1E1E] mb-1 sm:mb-2 md:mb-3 lg:mb-4">
//           Description
//         </h2>

//         <div className="space-y-4 sm:space-y-5 lg:space-y-6">
//           <p className="font-normal text-[18px] text-[#424242]">
//             Founded in 1946, DLF (Delhi Land & Finance) is one of India’s most
//             prominent real estate companies. It started with developing
//             residential colonies in Delhi and later expanded into residential,
//             commercial, retail, and hospitality projects across India. Today,
//             DLF is known for creating integrated townships, IT parks, luxury
//             malls, and premium housing projects.
//           </p>

//           <p className="font-normal text-[18px] text-[#424242]">
//             DLF shaped how modern real estate works in India—from large-scale
//             housing societies to corporate hubs. Its model of integrated living
//             + business ecosystems is widely copied by other developers.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// const DeveloperStatsCard = () => {
//   const stats = [
//     { number: 4, label: "New Launch" },
//     { number: 10, label: "Ready to Move" },
//     { number: 2, label: "Under Construction" },
//   ];

//   return (
//     <div className="w-full flex items-center justify-center">
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 w-full">
//         {stats.map((stat, index) => (
//           <div
//             key={index}
//             className="relative bg-white rounded-lg shadow-md p-6 sm:p-8"
//           >
//             {/* Blue vertical bar */}
//             <div className="absolute left-0 top-0 w-5 h-full bg-gradient-to-r from-[#B9D1FF] to-[#6F7E99] rounded-lg"></div>

//             {/* Content */}
//             <div className="ml-4 sm:ml-6">
//               <h3 className="font-semibold text-[40px] leading-[100%] text-[#1E1E1E]">
//                 {stat.number.toString().padStart(2, "0")}
//               </h3>
//               <p className="font-medium text-[18px] text-[#696969]">
//                 {stat.label}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// const CompanyDetails = () => {

//   const { id } = useParams();
//   return (
//     <div className="w-full overflow-hidden">
//       <CompanyProfile />

//       {/* Main Content Section */}
//       <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 px-4 sm:px-6 lg:px-10 py-10">
//         <div className="lg:col-span-3 space-y-10">
//           <DeveloperDescription />
//           <DeveloperStatsCard />
//           <NewLaunchListings />
//           <ReadyToMove />
//           <UnderConstruction />
//         </div>

//         {/* Right Section (Contact Form) */}
//         <div className="lg:col-span-1">
//           <ContactForm />
//         </div>
//       </div>

//       {/* Top Developers */}
//       <div className="px-4 sm:px-6 lg:px-10 pb-10">
//         <BhubaneswarTopDeveloper />
//       </div>
//     </div>
//   );
// };

// export default CompanyDetails;
